import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { MessageService } from "primeng/api";

import { SessionService } from "../../common/services/session.service";
import { UtilityService } from "../../shared/utility.service";
import { UserService } from "../../UserManagement/userService/api/user.service";
import { OfficeService } from "../officeService/api/office.service";

// var pageConfigFromJson = require("../../../assets/page-configs/office-list.json");
@Component({
  selector: "app-office-report",
  templateUrl: "./office-report.component.html",
  styleUrls: ["./office-report.component.scss"],
})
export class OfficeReportComponent implements OnInit {
  userInfo: any;
  officeData: any;
  officeId: any;
  OfficeListData: any;
  viewerFlag: boolean = false;
  currentRoute: string;
  isPagination: boolean;
  dialougFlag: boolean = false;
  changeData: any;
  config: any;
  isActionAllowed: boolean = false;
  entityName: string = "officeImage";

  chartOptions = {
    title: {
      display: false,
      text: "My Title",
    },
    legend: {
      display: false,
    },
    cutoutPercentage: 80, //Here for innerRadius. It's already exists
    outerRadius: 100, //Here for outerRadius
  };
  constructor(
    private officeService: OfficeService,
    private toast: MessageService,
    private router: Router,
    private sessionService: SessionService,
    private userService: UserService,
    private readonly us: UtilityService
  ) {
    this.OfficeListData = [];
    this.currentRoute = "DASHBOARD";
    if (this.router.url && this.router.url.indexOf("/office/list") !== -1) {
      this.currentRoute = "OFFICE_LIST";
      this.isPagination = true;
    } else {
      this.isPagination = false;
    }
  }

  //soft Delete Call
  deleteRecord(officeData) {
    officeData.recordStatus = "DELETED";
    this.officeService.updateData(officeData).subscribe((res) => {
      this.toast.add({
        severity: "error",
        summary: "Deleted Successfully",
        detail: "Office Entry Deleted successfully !!!",
      });
    });
  }

  getOfficeList() {
    this.officeService.getOfficeDashboardData().subscribe(
      (resp) => {
        this.OfficeListData = resp;
      },
      (error) => {}
    );
  }

  editOffice(office) {
    this.officeId = office ? office.id : null;
    this.router.navigate(["/office/edit/" + this.officeId]);
  }

  createOfficeAdmin(office) {
    this.officeId = office ? office.id : null;
    this.router.navigate(["/office/create/admin/" + this.officeId]);
  }

  editOfficeAdmin(user, office) {
    let officeId = office ? office.id : null;
    let userId = user ? user.id : null;

    this.router.navigate(["/office/" + officeId + "/create/admin/" + userId]);
  }

  opendialoug(obj) {
    this.dialougFlag = true;
    this.changeData = obj;
  }

  assginAsOfficeAdmin(office) {
    this.userService.assignAsAdmin(office).subscribe((res: any) => {
      this.router.navigate(["/login"]);
      this.dialougFlag = false;
    });
  }

  openVirtualViewOffice($event, item) {
    this.us.setOfficeForVirtualView(item);
    $event.stopPropagation();
    $event.preventDefault();
  }

  deleteOffice(id) {
    this.officeService.deleteOfficeData(id).subscribe((resp) => {});
  }

  getPageConfig() {
    this.officeService.getPageConfig().subscribe((res) => {
      this.config = res;
      this.config["officeDataList"].pagination=this.isPagination;
   
      if (
        (this.router.url && this.router.url.indexOf("/admin-dashboard") > -1) ||
        (this.router.url && this.router.url.indexOf("/viewer-dashboard") > -1)
      ) {
        this.isActionAllowed = true;
        this.config["officeDataList"].columns = this.config[
          "officeDataList"
        ].columns.filter((col) => ["Actions"].includes(col.header) == false);
      }
      this.getOfficeList();
    });
  }

  handleEvent(event) {
    if (event.name == "LAZY_LOAD") {
      this.getOfficeList();
    }
  }

  ngOnInit() {
    this.getPageConfig();
    setTimeout(() => {
      this.userInfo = this.sessionService.getUserInfo();
      this.officeData = this.sessionService.getOffice();

      if (this.userInfo.role == "VIEWER") {
        this.viewerFlag = true;
      }
    });
    if (this.router.url && this.router.url.indexOf("/office/list") > -1) {
      this.isActionAllowed = true;
    }
  }
}
